import { 
  socialService as sharedSocialService
} from '@watchlist/shared';

// Re-export the shared social service for backward compatibility
export const socialService = sharedSocialService; 